import { ApiResponse } from '@manigo/manigo-commons';


export const FETCH_TRANSACTIONS_LIST = 'FETCH_TRANSACTIONS_LIST';
export const FETCH_TRANSACTIONS_LIST_SUCCESS = 'FETCH_TRANSACTIONS_LIST_SUCCESS';
export const FETCH_TRANSACTIONS_LIST_FAILURE = 'FETCH_TRANSACTIONS_LIST_FAILURE';
export const CLEAR_TRANSACTIONS_LIST = 'CLEAR_TRANSACTIONS_LIST';


export const SHOW_DOWNLOAD_RECEIPT_ATTACHMENT_FORM = 'SHOW_DOWNLOAD_RECEIPT_ATTACHMENT_FORM';
export interface ShowDownloadReceiptAttachmentFormPayload {
    receiptId: number,
}
export const HIDE_DOWNLOAD_RECEIPT_ATTACHMENT_FORM = 'HIDE_DOWNLOAD_RECEIPT_ATTACHMENT_FORM';
export interface HideDownloadReceiptAttachmentFormPayload {
    receiptId: number,
}

export interface DeleteReceiptPayload {
    queryParams: {
        receiptId: number,
        transactionId: number
    },
    locationPathname: string,
}

export const FETCH_TRANSACTION_DETAILS = 'FETCH_TRANSACTION_DETAILS';
export const FETCH_TRANSACTION_DETAILS_SUCCESS = 'FETCH_TRANSACTION_DETAILS_SUCCESS';
export const FETCH_TRANSACTION_DETAILS_FAILURE = 'FETCH_TRANSACTION_DETAILS_FAILURE';

export const DELETE_RECEIPT = 'DELETE_RECEIPT';
export const DELETE_RECEIPT_SUCCESS = 'DELETE_RECEIPT_SUCCESS';
export const DELETE_RECEIPT_FAILURE = 'DELETE_RECEIPT_FAILURE';

export interface DeleteReceiptSuccessPayload {
    responsePayload: ApiResponse<null>
}


export const DOWNLOAD_RECEIPT_ATTACHMENT = 'DOWNLOAD_RECEIPT_ATTACHMENT';
export const DOWNLOAD_RECEIPT_ATTACHMENT_SUCCESS = 'DOWNLOAD_RECEIPT_ATTACHMENT_SUCCESS';
export const DOWNLOAD_RECEIPT_ATTACHMENT_FAILURE = 'DOWNLOAD_ACCOUNT_STATEMENT_PDF_FAILURE';

export interface DownloadReceiptAttachmentPayload {
    queryParams: {
        receiptId: number,
        url: string
        // currency: AccountDetails['currency'],
        // dateFrom: string,
        // dateTo: string,
    }
}

export interface DownloadReceiptAttachmentSuccessPayload {
    receiptId: number,
}

export interface DownloadReceiptAttachmentFailurePayload {
    receiptId: number,
}

